import React, { useState } from 'react'

const TfgContext = React.createContext({})

export const TfgContextProvider = ({ children }) => {
  const [tfgConfig, setTfgConfig] = useState(null)

  const context = {
    setTfgConfig,
    tfgConfig
  }

  return <TfgContext.Provider value={context}>{children}</TfgContext.Provider>
}

export const useTfgContext = () => React.useContext(TfgContext)
